import styled from 'styled-components';
import { ChipProps } from './types';
import { screens } from '../../../features/Theme/domain/breakpoints';

export const ChipContainer = styled.div<Partial<ChipProps>>`
  width: fit-content;
  background-color: ${({ $bgColor }) => $bgColor ?? '#DBF2F8'};
  color: ${({ $color }) => $color ?? '#292c32'};
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;

  font-size: 0.75rem;
  line-height: 0.875rem;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};

  @media ${screens.screenGTS} {
    line-height: 1rem;
  }

  text-transform: uppercase;
  border: ${({ $hasBorder }) => $hasBorder ? `1px solid #c8cbce` : 'none'};
`;